<div *ngIf="type == 'vertical'; else horizontal;">
  <div class="app-card-box card-box__custom-dm d-flex flex-column p-none h-100"
       *ngIf="!showSkeleton && news; else vertical_skt"
       [ngClass]="{'scroll-item-width': !fullWidth, 'w-100': fullWidth}"
       (click)="onOpenLink()">

    <div class="news-image-box app-border-radius top"
         [class.white-background]="!showLogo"
         [class.contain]="!showLogo && showContain"
         [appBackgroundImage]="news?.imageUrl">
      <div style="position: relative;"
           class="overlay-img shadow-none d-flex flex-column ion-justify-content-between app-border-radius top">
        <img class="andria-viva-logo-img"
             style="position: absolute;top: 6px; right: 6px;"
             *ngIf="showLogo && news?.logo"
             [src]="news?.logo">
      </div>
    </div>
    <div class="p-sm"
         style="flex: 1;min-width: 0;">

      <div class="news-title">{{ news.title }}</div>
      <div class="ts-small-bold pt-sm text-azzurro-500 read-more">
        <div>Leggi di più</div>
        <div class="material-symbols-outlined">chevron_right</div>
      </div>

    </div>
  </div>
</div>

<ng-template #horizontal>
  <div *ngIf="!showSkeleton && news; else horizontal_skt"
       (click)="onOpenLink()"
       class="app-card-box d-flex gap-4 container__horizontal">
    <div [appBackgroundImage]="news.imageUrl"
         class="news-image__horizontal"></div>
    <div>
      <div class="news-title__horizontal">{{ news.title }}</div>
      <div class="ts-small-bold pt-sm text-azzurro-500 read-more">
        <div>Leggi di più</div>
        <div class="material-symbols-outlined">chevron_right</div>
      </div>
    </div>
  </div>
</ng-template>

<ion-modal #detailModal
           [initialBreakpoint]="1"
           [breakpoints]="[0, 1]">
  <ng-template>

    <div class="image-header" *ngIf="news?.imageUrl">
      <img [src]="news?.imageUrl"
           [class]="!showLogo ? 'contain' : ''"
           class="image-header-img">

      <ion-fab-button class="white close-btn"
                      (click)="detailModal.dismiss()">
        <span class="material-symbols-outlined">close</span>
      </ion-fab-button>
    </div>

    <ion-content class="ion-padding">
      <div class="ts-h5 news-title__detail">{{ news?.title }}</div>
      <div class="ts-small text-neutral-600 mt-xsm">{{ news?.pubDate | appDate: 'DD MMMM YYYY HH:mm' }}</div>
      <div class="ts-caption mt-sm" [innerHTML]="news?.truncatedDescription"></div>
    </ion-content>

    <ion-footer class="ion-no-border">
      <div class="ion-padding">
        <div class="d-flex">
          <ion-button (click)="onOpenExternalNews()" class="w-100 primary">
            <span>{{ 'Leggi_notizia_completa' | translate }}</span>
          </ion-button>
          <ion-button (click)="onShare(news)" class="default">
            <ion-icon name="share-outline"></ion-icon>
          </ion-button>
        </div>
      </div>
    </ion-footer>

  </ng-template>
</ion-modal>

<ng-template #horizontal_skt>
  <app-new-item-skeleton [fullWidth]="fullWidth"
                         type="horizontal"/>
</ng-template>

<ng-template #vertical_skt>
  <app-new-item-skeleton [fullWidth]="fullWidth"
                         type="vertical"/>
</ng-template>


